import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { ManyButtInColorBottomSheetComponent } from '../../../../../components/many-butt-in-color-bottom-sheet/many-butt-in-color-bottom-sheet.component';
import { CuttingButt } from '../../../../../models/cutting/cutting-butt.model';
import {
  MaterialBaseButtsDialogComponent,
  MaterialBaseEdgeDialogData,
} from '../../../../material-base-butts-dialog/material-base-butts-dialog.component';

// @dynamic
@Component({
  selector: 'csl-butt-for-all-sides-bottom-sheet',
  templateUrl: './butt-for-all-sides-bottom-sheet.component.html',
  styleUrls: ['./butt-for-all-sides-bottom-sheet.component.scss'],
})
export class ButtForAllSidesBottomSheetComponent implements OnInit {
  materialBaseDialogRef: MatDialogRef<MaterialBaseButtsDialogComponent>;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ManyButtInColorBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { butts: CuttingButt[]; panelThickness: number },
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  selectButt(butt: CuttingButt): void {
    this.bottomSheetRef.dismiss(butt);
  }

  openButtListDialog(): void {
    this.materialBaseDialogRef = this.dialog.open(MaterialBaseButtsDialogComponent, {
      panelClass: 'material-base-butt-list-dialog',
      disableClose: false,
      width: '1000px',
      data: {
        panelThickness: this.data.panelThickness,
      } as MaterialBaseEdgeDialogData,
    });

    this.materialBaseDialogRef.afterClosed().subscribe((result: CuttingButt | undefined) => {
      if (result) {
        this.selectButt(result);
      }
      this.materialBaseDialogRef = null;
    });
  }
}
